<template>
	<app tabbar :create-button="!!createPath" @create="navigateTo(createPath)">
		<scroll-list ref="list">
			<template v-slot="{data}">
				<scroll-item>
					<div class="flex-between-center">
						<div class="code">创建时间：{{data.create_date}}</div>
						<div class="info"><span :style="{'color': ledgerState[data.state].color}">{{ledgerState[data.state].name}}</span></div>
					</div>
					<div class="name">{{data.project_name}}</div>
					<div class="info">业主单位：{{data.yzdw_name}}</div>
					<div class="info">监理单位：{{data.jldw_name}}</div>
					<button-group slot="button">
						<c-button v-if="data.state == 1 && power('8')" @click="navigateTo('/ledger_detail', {id: data.id})">签署</c-button>
						<c-button v-else color="gray" hollow @click="navigateTo('/ledger_detail', {id: data.id})">查看详情</c-button>
						<c-button v-if="data.state == 4 && power('7')" @click="navigateTo('/ledger_apply', {id: data.id})">重新编辑</c-button>
					</button-group>
				</scroll-item>
			</template>
		</scroll-list>
	</app>
</template>

<script>
	import {mapGetters} from 'vuex'
	
	export default {
		computed: {
			...mapGetters(['power', 'ledgerState']),
			
			createPath() {
				if (this.power('7')) {
					return '/ledger_apply';
				}
			}
		},
		
		mounted() {
			this.updateList();
		},
		
		methods: {
			updateList() {
				this.$refs.list.load({
					url: '/project/aqtz/list'
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
